/* eslint-disable import/no-extraneous-dependencies */
import Vue from 'vue';
import VueRouter from 'vue-router';
import Home from '../views/Home.vue';
import Themes from '../views/Themes.vue';
import Theme from '../views/Theme.vue';
import Form from '../views/Form.vue';

Vue.use(VueRouter);

const routes = [
  {
    path: '/themes',
    name: 'Themes',
    component: Themes,
  },
  {
    path: '/theme/:id',
    name: 'Theme',
    component: Theme,
  },

  {
    path: '/form',
    name: 'Form',
    component: Form,
  },

  {
    path: '/',
    name: 'Home',
    component: Home,
  },

  {
    path: '/*',
    redirect: '/',

  },
];

const router = new VueRouter({
  routes,
  scrollBehavior() {
    return { x: 0, y: 0 };
  },
});

export default router;
